import { UserManagerSettings } from "oidc-client-ts"

export const createOIDCConfig = (): UserManagerSettings => {
  const keycloakUrl = import.meta.env.REACT_APP_KEYCLOAK_URL
  const realm = import.meta.env.REACT_APP_KEYCLOAK_REALM
  const clientId = import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID
  const redirectUri =
    import.meta.env.REACT_APP_KEYCLOAK_REDIRECT_URI ||
    `${window.location.origin}/auth/callback`
  const postLogoutRedirectUri =
    import.meta.env.REACT_APP_KEYCLOAK_POST_LOGOUT_REDIRECT_URI ||
    `${window.location.origin}/logout`

  if (!keycloakUrl || !realm || !clientId) {
    throw new Error(
      "Missing required Keycloak configuration. Please check your .env file.",
    )
  }

  const authority = `${keycloakUrl}/realms/${realm}`

  return {
    authority,
    client_id: clientId,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri,
    response_type: "code",
    scope: "openid profile offline_access ADV_frontend",
    automaticSilentRenew: false,
    includeIdTokenInSilentRenew: false,
    loadUserInfo: false, // Отключаем автоматическую загрузку userinfo для избежания дополнительных запросов
    filterProtocolClaims: true,
    extraQueryParams: {},
    extraTokenParams: {},
    fetchRequestCredentials: "omit", // Возвращаем omit, чтобы избежать preflight запросов
    metadata: {
      issuer: authority,
      authorization_endpoint: `${authority}/protocol/openid-connect/auth`,
      token_endpoint: `${authority}/protocol/openid-connect/token`,
      userinfo_endpoint: `${authority}/protocol/openid-connect/userinfo`,
      end_session_endpoint: `${authority}/protocol/openid-connect/logout`,
      jwks_uri: `${authority}/protocol/openid-connect/certs`,
      code_challenge_methods_supported: ["S256"],
    },
    stateStore: undefined,
    userStore: undefined,
  }
}

export const oidcConfig = createOIDCConfig()
